import script from "./insureGrade.vue?vue&type=script&setup=true&lang=js"
export * from "./insureGrade.vue?vue&type=script&setup=true&lang=js"

import "./insureGrade.vue?vue&type=style&index=0&id=7c9c996d&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c9c996d"]])

export default __exports__